export default "__VITE_ASSET__Dlb06ZqZ__"